import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import LandingPageHeader from '../LandingPageHeader/LandingPageHeader';
import { HEADER_LOGO_HEIGHTS } from '../NewHeader/consts';
import ProjectLogo from '../ProjectLogo/ProjectLogo';
import { EegLandingPageHeaderProps } from './types';

const EegLandingPageHeader = (props: EegLandingPageHeaderProps) => {
  const isMobile = useIsMobile(BreakPoint.LG);

  return (
    <LandingPageHeader
      {...props}
      logo={
        <ProjectLogo
          project="eeg"
          height={HEADER_LOGO_HEIGHTS.eeg[isMobile ? 'mobile' : 'desktop']}
        />
      }
    />
  );
};

export default EegLandingPageHeader;
